<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="description" slot-scope="description">
          <div>{{description}}</div>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
<!--            <a-tooltip-->
<!--              placement="top"-->
<!--              title="Create inward transaction"-->
<!--            >-->
<!--              <a href="javascript:"  class="btn btn-sm btn-success mr-2" @click="showInwardTransactionModal(record)">-->
<!--              <span class="btn-addon">-->
<!--                <i class="btn-addon-icon fa-lg fe  fe-plus-square" />-->
<!--              </span>-->
<!--              </a>-->
<!--            </a-tooltip>-->
            <a-tooltip
              placement="top"
              title="Issue bundled transaction"
            >
              <a href="javascript:" class="btn btn-sm btn-warning btn-with-addon mr-2" @click="showOutwardTransactionModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fa-lg fe fe-minus-square" />
              </span>
                Issue
              </a>
            </a-tooltip>
            <a-tooltip
              placement="top"
              title="Edit bundled product"
            >
              <a href="javascript:" class="btn btn-sm btn-light btn-with-addon mr-2" @click="showEditModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
                Edit
              </a>
            </a-tooltip>

            <a-tooltip
              placement="top"
              title="Delete bundled product"
            >
              <a href="javascript:" class="btn btn-sm btn-danger btn-with-addon" @click="handleDelete(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
                Delete
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
    <edit-product @onEdited="handleAfteredit"></edit-product>
<!--    <inward-transaction @onInwardTransaction="handleAfteredit"></inward-transaction>-->
    <outward-transaction :bundledProductProducts="bundledProductProducts" @onOutwardTransaction="handleAfteredit"></outward-transaction>
  </div>
</template>

<script>
import EditProduct from '@/components/inventory/bundled_products/editBundledProduct'
// import InwardTransaction from '@/components/inventory/master/product/inwardTransaction'
import OutwardTransaction from '@/components/inventory/bundled_products/outwardTransaction'

const columns = [
  { title: 'Bundled Code', dataIndex: 'code', scopedSlots: { customRender: 'code' } },
  { title: 'Name', dataIndex: 'name', scopedSlots: { customRender: 'name' } },
  { title: 'Description', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'bundledProductsTable',
  components: {
    EditProduct,
    OutwardTransaction,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
      // data: [],
      productGroupings: [],
      productCounter: 0,
      productGroups: [],
      prodGroupSpinning: false,
      items: [],
      bundledProductProducts: [],
    }
  },
  /* mounted: function () {
    this.fetchdata()
  }, */
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  // mounted: {
  //   this.showOutwardTransactionModal()
  // },
  methods: {
    handleAfteredit() {
      this.$emit('updateTable')
    },
    // showInwardTransactionModal(record) {
    //   this.$eventBus.$emit('showInwardTransactionForm', record)
    // },
    showOutwardTransactionModal(record) {
      this.$eventBus.$emit('showOutwardTransactionForm', record)
      this.$http.get(`/api/inventory/bundled_product/${record.id}/products`)
        .then((resp) => {
          this.bundledProductProducts = resp.data.products
          console.log('New Products API', resp)
        })
        .catch(err => {
          console.log(err)
        })
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this bundled product.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/inventory/bundled_product/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              if (resp.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()

                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The product has been deleted.',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>

<style>

</style>
